import styled from "styled-components";

export const UnStyledHyperLink = styled.a`
  cursor: pointer;
  border: none;
  outline: none;
  background: none;
  color: inherit;
`;
